import { TBoardId } from '../../../../../../../../types/types';
import { ISettingsSectionOwnProps } from '../../../../../../base/components/SettingsSection/types';

export interface ITabDetailsFields extends
    ISettingsSectionOwnProps
{
    boardId: TBoardId;
    isNewFeature?: boolean;
    isBoardSplitSettings: boolean;
}

export interface ITabDetailsEvents {
    onSubTabChange: () => void;
}

export interface ITabDetailsProps extends
    ITabDetailsFields,
    ITabDetailsEvents
{}

export enum EBoardSetting {
    // board info
    INFO = 'INFO',

    // notifications
    EMAIL_NOTIFICATIONS = 'EMAIL_NOTIFICATIONS',
    APP_NOTIFICATIONS = 'APP_NOTIFICATIONS',

    // card settings
    CARD_PREFIXES = 'CARD_PREFIXES',
    CARD_PROPERTIES = 'CARD_PROPERTIES',
    CUSTOM_PROPERTIES = 'CUSTOM_PROPERTIES',
    COLOR_LABELS = 'COLOR_LABELS',
    TAGS = 'TAGS',
    ROLES = 'ROLES',
    DATES_TIME = 'TIME',

    // automations
    CARD_AGING = 'CARD_AGING',
    GANTT = 'GANTT',
    ARCHIVE_UPON_DELETION = 'ARCHIVE_UPON_DELETION',
    LINKS_PREVIEW = 'LINKS_PREVIEW',
    STATUS_MAPPING = 'STATUS_MAPPING',
    ESTIMATE = 'ESTIMATE',
    WEBHOOKS = 'WEBHOOKS',

    // other
    TIME_ZONE = 'TIME_ZONE',
    BOARD_EMAIL = 'BOARD_EMAIL',

    // actions
    IMPORT_PWC = 'IMPORT_PWC',
    IMPORT = 'IMPORT',
}
